import React from 'react'
import bodyWaxingRightBanner from "./../../../../../Images/Blog/BodyWaxingRight/Banner.png";

const BodyWaxingRightImg = () => {
  return (
    <div className="blogImg-content">
      <img src={bodyWaxingRightBanner} alt="Body Waxing Right Banner" loading="lazy" />
    </div>
  )
}

export default BodyWaxingRightImg
